import React, { useEffect } from 'react'
import { Modal, Button, Form } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { BsCheckCircleFill } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import SafeFormatMessage from '../Shared/SafeFormatMessage/SafeFormatMessage'
import { Wrapper } from './GenerateSubscriptionPaymentLinkModal.styled'
import useRequest from '../../../axios/apis/useRequest'

const GenerateSubscriptionPaymentLinkModal = ({
  setVisible,
  subscriptionId,
}) => {
  const { subscriptionPaymentLink } = useRequest()
  const [paymentLink, setPaymentLink] = React.useState('')

  const direction = useSelector((state) => state.main.direction)

  useEffect(() => {
    if (!subscriptionId) return
    ;(async () => {
      const request = await subscriptionPaymentLink(subscriptionId, {
        paymentPlatform: null,
      })
      setPaymentLink(request.data.data.paymentLink)
    })()
  }, [subscriptionId])

  const handleCopyToClipboard = () => {
    if (paymentLink) {
      navigator.clipboard.writeText(paymentLink)
    }
  }

  return (
    <Wrapper>
      {paymentLink ? (
        <Form>
          <Modal.Header>
            <Modal.Title>
              <>
                <BsCheckCircleFill
                  style={{ color: 'green', marginLeft: '5px' }}
                />
                <span style={{ color: 'green', marginLeft: '5px' }}>
                  <SafeFormatMessage id="Payment-link-generated-successfully" />
                </span>
              </>
            </Modal.Title>
            <Button
              variant="close"
              aria-label="Close"
              onClick={() => setVisible(false)}
            />
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>
                <SafeFormatMessage id="Payment-Link" />
              </Form.Label>
              <div
                className={
                  direction === 'rtl'
                    ? 'input-group input-group-rtl'
                    : 'input-group'
                }
              >
                <input
                  type="text"
                  className="form-control"
                  value={paymentLink}
                  readOnly
                />
                <span className="input-group-text">
                  <FontAwesomeIcon
                    icon={faCopy}
                    onClick={handleCopyToClipboard}
                    style={{ cursor: 'pointer' }}
                  />
                </span>
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setVisible(false)}>
              <SafeFormatMessage id="Close" />
            </Button>
          </Modal.Footer>
        </Form>
      ) : (
        <Form>
          <Modal.Header>
            <Modal.Title>
              <>
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                  style={{ color: 'orange', marginRight: '10px' }}
                />
                <span style={{ color: 'orange', marginRight: '10px' }}>
                  <SafeFormatMessage id="Payment-link-in-progress" />
                </span>
              </>
            </Modal.Title>
            <Button
              variant="close"
              aria-label="Close"
              onClick={() => setVisible(false)}
            />
          </Modal.Header>
          <Modal.Body>
            <p>
              <SafeFormatMessage id="The-payment-link-is-being-generated-or-unavailable-please-await-or-try-again-later" />
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setVisible(false)}>
              <SafeFormatMessage id="Close" />
            </Button>
          </Modal.Footer>
        </Form>
      )}
    </Wrapper>
  )
}

export default GenerateSubscriptionPaymentLinkModal
